import { LogDTO } from './../../models/logDTO';
import { LogService } from './../../services/log/log.service';
import { FunctionsService } from './../../services/common/functions.service';
import { ENTIDADE } from './../../config/entidade.config';
import { CandidatoService } from './../../services/candidato/candidato.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-log',
  templateUrl: './log.component.html',
  styleUrls: ['./log.component.scss'],
})
export class LogComponent implements OnInit {

  idEntidade: number;
  entidade: string;

  idEntidade2: number;
  entidade2: string;

  logs: LogDTO[] = [];
  loading: boolean = false;

  constructor( private logService: LogService
             , private functionsService: FunctionsService ) { 

  }

  ngOnInit() {
    console.log(this.entidade,this.idEntidade)
    console.log(this.entidade2,this.idEntidade2)
  }



  ionViewWillEnter(){
       
    this.functionsService.presentLoading();
    this.loading = true;

    this.logService.findByEntidadeAndId(this.entidade, this.idEntidade).subscribe({
      next:(resp)=>{ 

        for(var log of resp){
          log.descricaoOperacao = this.formatarStatus(log.descricaoOperacao);
          log.descricaoOperacao = this.formatarFormaIngresso(log.descricaoOperacao);          
        }
        this.logs = resp;

        
        if(this.entidade2 && this.idEntidade2){

          this.logService.findByEntidadeAndId(this.entidade2, this.idEntidade2).subscribe({
            next:(resp2)=>{
  
              if(!this.logs){
                this.logs = [];
              }

              for(var log of resp2){
                log.descricaoOperacao = this.formatarStatus(log.descricaoOperacao);
                log.descricaoOperacao = this.formatarFormaIngresso(log.descricaoOperacao);
              }

              this.logs.push(...resp2);
  
              this.loading = false;
              this.functionsService.dismissLoading();
              
            },
            error:(error2)=>{
              console.log(error2);
              this.functionsService.dismissLoading();
            }
          });

        }else{
          this.loading = false;
          this.functionsService.dismissLoading();
        }
        
        

      },
      error:(error)=>{
        console.log(error);
        this.functionsService.dismissLoading();

      }
    });
  }

  formatarStatus(descricaoLog: string): string {
    return descricaoLog
      .replace(/ISENTO_PAGAMENTO/g, 'Isento de Pagamento')
      .replace(/AGUARDANDO_PAGAMENTO/g, 'Aguardando Pagamento')
      .replace(/PAGO/g, 'Pago')
      .replace(/CANCELADO/g, 'Cancelado')
      .replace(/CLASSIFICADO/g, 'Classificado')
      .replace(/NAO_CLASSIFICADO/g, 'Não Classificado')
      .replace(/AUSENTE/g, 'Ausente')
      .replace(/ESPERA/g, 'Em Lista de Espera')
      .replace(/NAO_COMPARECEU_MATRICULA/g, 'Não Compareceu para Matrícula')
      .replace(/MATRICULADO/g, 'Matriculado')
      .replace(/RECLASSIFICACAO_1/g, 'Reclassificação 1ª Chamada')
      .replace(/RECLASSIFICACAO_2/g, 'Reclassificação 2ª Chamada')
      .replace(/RECLASSIFICACAO_3/g, 'Reclassificação 3ª Chamada')
      .replace(/RECLASSIFICACAO_4/g, 'Reclassificação 4ª Chamada')
      .replace(/RECLASSIFICACAO_5/g, 'Reclassificação 5ª Chamada')
      .replace(/RECLASSIFICACAO_6/g, 'Reclassificação 6ª Chamada')
      .replace(/RECLASSIFICACAO_7/g, 'Reclassificação 7ª Chamada')
      .replace(/DOCUMENTACAO_MATRICULA_ENVIADA/g, 'Documentação de Matrícula Enviada')
      .replace(/DOCUMENTACAO_MATRICULA_PENDENTE/g, 'Documentação de Matrícula Pendente')
      .replace(/TERMO_EMITIDO/g, 'Termo Emitido')
      .replace(/TERMO_ASSINADO/g, 'Termo Assinado')
      .replace(/MATRICULADO_COM_RESSALVAS/g, 'Matriculado com Ressalvas')
      .replace(/DEFERIDO/g, 'Deferido')
      .replace(/INDEFERIDO/g, 'Indeferido')
      .replace(/ELIMINADO/g, 'Eliminado')
      .replace(/CURSO_CONCLUIDO/g, 'Curso Concluído')
      .replace(/DOCUMENTACAO_INSCRICAO_ENVIADA/g, 'Documentação de Inscrição Enviada')
      .replace(/DOCUMENTACAO_INSCRICAO_PENDENTE/g, 'Documentação de Inscrição Pendente')
      .replace(/DESCLASSIFICADO/g, 'Desclassificado');
  }


  formatarFormaIngresso(descricaoLog: string): string {
    return descricaoLog
      .replace(/VESTIBULAR_ONLINE/g, 'Vestibular Online')
      .replace(/VESTIBULAR_PRESENCIAL/g, 'Vestibular Presencial')
      .replace(/ENEM/g, 'ENEM')
      .replace(/PORTADOR_DIPLOMA/g, 'Portador de Diploma')
      .replace(/TRANSFERENCIA/g, 'Transferência')
      .replace(/REINGRESSO_POS_ABANDONO/g, 'Reingresso após Abandono')
      .replace(/CURSO_EXTENSAO/g, 'Curso de Extensão')
      .replace(/POS_GRADUACAO/g, 'Pós-graduação');
  }

}
